module.exports = __webpack_public_path__ + "img/y_p3_y1.b3c2fb9a.png";